import React, { useState } from "react"
import { useTranslation } from 'react-i18next'
import { Modal } from 'react-bootstrap'

import { PUT } from 'helpers/api'

import { currencyLabel, expenseAccountName, expenseTotal, formatAmount } from './financeUtils'

// cancels every amountDetails row (cash and terminal) of the expense
function CancelExpense({ show, item, onHide, onCanceled }) {
	const { t } = useTranslation()

	const [saving, setSaving] = useState(false)

	const account = item ? expenseAccountName(item, t) : ''

	// shiftId is null for SAFE
	async function cancel() {
		const request = {
			sourceType: item.sourceType,
			shiftId: item.shiftId,
			expenseIds: (item.amountDetails || []).map(detail => detail.id),
		}

		setSaving(true)
		try {
			const response = await PUT('/services/web/api/expense-cancel', request, { loader: true })
			if (response) {
				onCanceled()
			}
		} finally {
			setSaving(false)
		}
	}

	return (
		<Modal show={show} centered dialogClassName="fo-cancel-modal" onHide={onHide}>
			{item &&
				<>
					<Modal.Body className="d-flex gap-3">
						<div className="fo-cancel-icon">
							<i className="uil uil-exclamation-triangle"></i>
						</div>
						<div>
							<h5 className="mb-1">{t('FO_CANCEL_OPERATION')}</h5>
							<div className="text-muted">
								{[
									t('FO_OTHER_EXPENSE'),
									item.expenseHelperName,
									formatAmount(expenseTotal(item), currencyLabel(item.currencyId, item.currencyName)),
								].filter(Boolean).join(' · ')}
							</div>
							{account &&
								<div className="text-muted text-sm mt-2">{t('FO_CANCEL_RETURN_NOTE', { account })}</div>
							}
						</div>
					</Modal.Body>
					<Modal.Footer>
						<button type="button" className="btn btn-outline-dark" onClick={onHide}>{t('BACK')}</button>
						<button type="button" className="btn btn-danger" disabled={saving} onClick={cancel}>
							<i className="uil uil-ban me-1"></i>
							{t('FO_YES_CANCEL')}
						</button>
					</Modal.Footer>
				</>
			}
		</Modal>
	)
}

export default CancelExpense
